import React, { Component } from "react";
import { useThemeStore } from "../stores/themeStore";

interface ThemeProviderProps {
    children: React.ReactNode;
}

/**
 * ThemeProvider — initialises the dark/light theme on mount and
 * listens for OS preference changes (relevant when mode is "system").
 */
class ThemeProvider extends Component<ThemeProviderProps> {
    private mediaQuery: MediaQueryList | null = null;
    private handleChange: ((e: MediaQueryListEvent) => void) | null = null;

    componentDidMount() {
        // Apply persisted (or default) theme immediately
        useThemeStore.getState().initializeTheme();

        // Listen for OS-level colour-scheme changes
        if (typeof window !== "undefined" && window.matchMedia) {
            this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
            this.handleChange = () => {
                // Re-apply if mode is "system"
                const state = useThemeStore.getState();
                if (state.mode === "system") {
                    state.setMode("system");
                }
            };
            this.mediaQuery.addEventListener("change", this.handleChange);
        }
    }

    componentWillUnmount() {
        if (this.mediaQuery && this.handleChange) {
            this.mediaQuery.removeEventListener("change", this.handleChange);
        }
    }

    render() {
        return <>{this.props.children}</>;
    }
}

export default ThemeProvider;
